export default __webpack_public_path__ + "static/media/tower.032d4d7b.svg";